import { Frontend } from "shared-types";
import axios from "../utils/axios";
// Frontend.Release.ReleaseMain
export const create = async (data: any) => {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    formData.append('avatar_file', data.avatar_file);
    const response = await axios.post(`/add-release`, formData);
    return response.data;
}

export const get = async (id: number): Promise<Frontend.Release.Release> => {
    const response = await axios.get(`/release/${id}`);
    return response.data.data;
}

export const editRelease = async (data: Frontend.Release.Release) => {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    formData.append('avatar_file', data.avatar_file);
    const response = await axios.post(`/edit-release/${data.id}`, formData);
    console.log(response);
}